import { PropsWithChildren } from 'react';
import './body-content.component.scss';

export const BodyContentComponent = ({ children }: PropsWithChildren) => {
  return <div className="body-content-breadcrumbs">{children}</div>;
};
